import React from 'react';

import Form from '@rjsf/core';
import { customizeValidator } from '@rjsf/validator-ajv8';
import PropTypes from 'prop-types';

import FormComponent from '@/components/common/Form/FormComponent';
import Theme from '@/components/common/Form/Theme';
import { customFormats } from '@/helpers/isValidDateTimeFormat';

const validator = customizeValidator({ customFormats });

const FormContainer = ({ schema, children: consumerChildren, ...props }) => {
  const { children: defaultChildren, widgets, ...templates } = React.useMemo(() => Theme(), []);

  return (
    <FormComponent
      Form={Form}
      schema={schema}
      validator={validator}
      templates={templates}
      widgets={widgets}
      {...props}
    >
      {consumerChildren || defaultChildren}
    </FormComponent>
  );
};

FormContainer.propTypes = {
  schema: PropTypes.object.isRequired,
};

export default FormContainer;
